import styled, { css } from 'styled-components';

import fontStyles from '@shared/design-tokens/fontStyles';
import colors from '@shared/design-tokens/colors';
import { Column, mediaCSS } from '@web-packages/library/layouts';

import types from './types';

const headerMargin = '5px 0px';

const margin = (_margin = headerMargin) => ({
  margin: _margin,
});

const commonTextCSS = (_css) => ({
  p: {
    ..._css,
  },
  h1: {
    ..._css,
  },
  h2: {
    ..._css,
  },
  h3: {
    ..._css,
  },
  h4: {
    ..._css,
  },
  h5: {
    ..._css,
  },
  br: {
    ..._css,
  },
  strong: {
    ..._css,
  },
});

const baseComponentCSS = css`
  ${{
    color: colors.core.darkBlue,
    wordBreak: 'break-word',
    h1: {
      ...fontStyles.core.headingXXL,
      ...margin(),
    },
    h2: {
      ...fontStyles.core.headingXL,
      ...margin(),
    },
    h3: {
      ...fontStyles.core.headingL,
      ...margin(),
    },
    h4: {
      ...fontStyles.core.subHeading,
      ...margin(),
    },
    h5: {
      ...fontStyles.core.textLead,
      ...margin(),
    },
    p: {
      margin: '0px',
      padding: '0px',
      ...fontStyles.core.textBasis,
    },
  }}
`;

const modalTypePhoneComponentCSS = css`
  ${{
    ...commonTextCSS({
      padding: '0px 10px',
    }),
    padding: '0px',
  }}
`;

const modalTypeCSS = css`
  padding: 0 32px;
  figure {
    margin: 0px;
  }

  img {
    border-radius: 8px;
  }

  h5,
  p,
  strong,
  br {
    max-width: 900px;
    ${mediaCSS.desktop({
    paddingLeft: ({ isModalTypeAndImage }) => isModalTypeAndImage && '110px',
    paddingRight: ({ isModalTypeAndImage }) => isModalTypeAndImage && '110px',
  })}
  }
  ${mediaCSS.maxWidthPhone(modalTypePhoneComponentCSS)}
`;

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled(Column)`
  ${baseComponentCSS}
  p, ul, li,span {
    ${({ customTextType }) => customTextType && {
    ...fontStyles.helper.getFontByKey(customTextType),
  }}
  }
  a {
    display: inline;
    padding: 0px;
  }

  ${({ type }) => type === types.modalType && modalTypeCSS};
  h5 > p {
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    font-style: inherit;
  }
  .line-break {
    white-space: pre-wrap;
  }
`;
